import { isNil } from 'lodash'

/**
 * Filters out null and undefined values from an array.
 */
export const excludeNilFilter = <T>(
  item: T
): item is Exclude<T, null | undefined> => {
  return !isNil(item)
}
